<template lang="pug">
v-icon.mr-2(
  :color='value ? `primary` : ``'
  :disabled='disabled'
) {{ value ? `fa fa-check-square` : `far fa-square` }}
</template>

<script>
export default {
  name: 'CustomField',
  props: ['value', 'disabled'],
}
</script>

<style scoped lang="sass">
</style>
